import isEmpty from "lodash-es/isEmpty";
import { Button, DeleteIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { EfsMelcoEfsModelsMappingListItem } from "melco-shared-logic";
import { Key } from "antd/lib/table/interface";
import { useConfirm } from "../../hooks/useConfirm";
import { useDeleteDesignMappings } from "../../hooks/designMappings/useDeleteDesignMappings";

type BulkActionDeleteDesignMappingsProps<T> = {
  selectedRowKeys: Key[];
  setSelectedRowKeys: (keys: Key[]) => void;
  refetch?: () => Promise<any>;
  data?: T[];
};

export const BulkActionDeleteDesignMappings: React.FC<
  BulkActionDeleteDesignMappingsProps<EfsMelcoEfsModelsMappingListItem>
> = ({ selectedRowKeys, setSelectedRowKeys, refetch }) => {
  const { t } = useTranslation();
  const deleteDesignMappings = useDeleteDesignMappings();

  const confirmDelete = useConfirm(
    async () => {
      const successfullyDeletedIds = await deleteDesignMappings(
        selectedRowKeys.map((key) => key.toString())
      );

      if (refetch) {
        refetch();
      }

      // keep items that were not deleted selected
      setSelectedRowKeys(
        selectedRowKeys.filter(
          (id) => !successfullyDeletedIds.includes(id.toString())
        )
      );
    },
    {
      translationPrefix: "designMappings.actions.delete",
      translationOptions: {
        count: selectedRowKeys.length,
      },
    }
  );

  if (isEmpty(selectedRowKeys)) {
    return null;
  }

  return (
    <Button
      key="bulk-delete"
      icon={<DeleteIcon />}
      onClick={() => {
        confirmDelete();
      }}
    >
      {t("inputFormats.actions.delete.button")}
    </Button>
  );
};
